/* eslint-disable jsx-a11y/media-has-caption */
import styles from '../../article.module.css';
import { Devices, useShowComponent } from '../VirtualArticle.hooks';

const VALID_AUDIO_TYPE = new Set(['mp3', 'soundcloud']);

export const VirtualAudio = (props: AudioProps) => {
	const {
		id,
		type,
		audioPath,
		bleed,
		caption,
		captionEnabled,
		devices,
		audioid,
	} = props;

	if (!VALID_AUDIO_TYPE.has(type)) {
		return null;
	}

	const deviceClassNames = useShowComponent(devices);
	const className = [styles['audio'], 'media', 'audio', deviceClassNames];
	if (bleed) {
		className.push('bleed');
	}

	let component = null;
	if (type === 'mp3') {
		if (!audioPath) {
			return null;
		}
		component = <Player path={audioPath} />;
	} else if (type === 'soundcloud') {
		if (!audioid) {
			return null;
		}
		component = <SoundCloud audioId={audioid} />;
	}

	if (id === 'Cf2-1764956224') {
		console.log(props);
	}

	return (
		<figure id={id} className={className.join(' ')}>
			{component}
			{captionEnabled && caption ? <Caption content={caption} /> : null}
		</figure>
	);
};

interface AudioProps {
	id: string;
	type: 'soundcloud' | 'mp3';
	audioPath: string;
	audioid: number;
	bleed: boolean;
	caption?: string;
	captionEnabled?: boolean;
	devices: Devices;
}

const Caption = ({ content }: CaptionProps) => {
	return <figcaption dangerouslySetInnerHTML={{ __html: content }} />;
};

interface CaptionProps {
	content: string;
}

const Player = ({ path }: PlayerProps) => {
	return (
		<audio controls>
			<source src={path} type={'audio/mpeg'} />
		</audio>
	);
};

interface PlayerProps {
	path: string;
}

const SoundCloud = ({ audioId }: SoundCloudProps) => {
	return (
		<iframe
			title={'Soundcloud Audio'}
			width="100%"
			height="166"
			allow="autoplay"
			src={`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${audioId}&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true`}
		/>
	);
};

interface SoundCloudProps {
	audioId: number;
}
